import { requestBuilder } from '../../http/RequestBuilder';

export interface RcdDepositRequest {
    accountId: string;
    checkAmountCents: number;
    frontImage: string;
    backImage: string;
}

export type RcdDepositResult =
    | {
          success: true;
          depositId: string;
          status: string;
      }
    | {
          success: false;
          userMessage: string;
      };

const useCreateRcdDeposit = requestBuilder.mutation<
    RcdDepositResult,
    RcdDepositRequest
>({
    endpoint: '/api/rcd',
    method: 'POST',
});

export default useCreateRcdDeposit;
